export default {

    "title": "Point",
    "entityName": "point",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [
        {
            md:11,
            value: "name",
            text: "Name",
            type: "text",
            table: {
                sortable: true,
                filter: true
            },
            validators: [
                "required"
            ]
        },
        {
            md:1,
            value: "enabled",
            text: "Enabled",
            type: "check",
            table: {
                sortable: true,
                filter: true
            },
            validators: [
            ]
        },
        {
            // full:true,
            value: "site_id",
            text: "Site",
            type: "autocomplete",
            title: "factor_label",
            // table: { "filter": true },
            validators: [
                "required"
            ],
            readonly: item => {
                return item.lab_id ? true : false
            },
            // visible: item => {
            //     return item.site_id || !item.id ? true : false
            // }
        },
        {
            // full:true,
            value: "lab_id",
            text: "Lab",
            type: "autocomplete",
            title: "name",
            // table: { "filter": true },
            validators: [
                "required"
            ],
            readonly: item => {
                return item.site_id ? true : false
            },
            // visible: item => {
            //     return item.lab_id || !item.id ? true : false
            // }
        },

        {
            slim:true,
            "value": "country_code",
            "text": "Country",
            "title": "name",
            "id": "code",
            "type": "autocomplete",
            // "readonly": item => { return item.id ? true : false },
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // },
            "validators": [
                "required",
            ],
            render: (item) => {
                return item.country.name + " (" + item.country.code + ")" 
            },
        },

        {
            semifull:true,
            readonly: item => { return !item.country_code ? true : false },
            type:"component",
            name:"vuetify-google-autocomplete",
            value:"google_address",
            bind: {
                id:"map",
                placeholder:"Search address",
            },
            on: (that) => ({
                placechanged: (data) => {
                    that.$root.$emit("itemUpdated", {field:{value:'google_address'}, selectedItem:data})
                },
            }),
           
        },
        {
            "value": "address",
            "text": "Address",
            "type": "text",
            table: { "filter": true },
            "validators": [
                "required"
            ],
            deps:['google_address'],
            default:(item, updatedField, selectedItem) => {
                if(updatedField.value == 'google_address') {
                    if(selectedItem && selectedItem.name)
                        return selectedItem.name
                }
            },
            readonly: item => { return !item.country_code ? true : false },
        },
        {
            mini:true,
            "value": "city",
            "text": "City",
            "type": "text",
            table: { "filter": true },
            "validators": [
                "required"
            ],
            deps:['google_address'],
            default:(item, updatedField, selectedItem) => {
                if(updatedField.value == 'google_address') {
                    if(selectedItem && selectedItem.locality)
                        return selectedItem.locality
                }
            },
            readonly: item => { return !item.country_code ? true : false },
        },

        {
            mini:true,
            "value": "prov",
            "text": "Prov",
            "type": "text",
            "validators": [
                "required"
            ],
            deps:['google_address'],
            default:(item, updatedField, selectedItem) => {
                if(updatedField.value == 'google_address') {
                    if(selectedItem && selectedItem.administrative_area_level_2)
                        return selectedItem.administrative_area_level_2
                }
            },
            readonly: item => { return !item.country_code ? true : false },  
        },

        {
            mini:true,
            "value": "cap",
            "text": "Postal Code",
            "type": "text",
            table: { "filter": true },
            "validators": [
                "required"
            ],
            deps:['google_address'],
            default:(item, updatedField, selectedItem) => {
                if(updatedField.value == 'google_address') {
                    if(selectedItem && selectedItem.postal_code)
                        return selectedItem.postal_code
                }
            },
            readonly: item => { return !item.country_code ? true : false },
        },

        {
            mini:true,
            "value": "lat",
            "text": "Latitude",
            "type": "text",
            "validators": [
                // "required"
            ],
            deps:['google_address'],
            default:(item, updatedField, selectedItem) => {
                if(updatedField.value == 'google_address') {
                    if(selectedItem && selectedItem.latitude)
                        return selectedItem.latitude
                }
            },
            readonly: item => { return !item.country_code ? true : false },
        },

        {
            mini:true,
            "value": "lon",
            "text": "Longitude",
            "type": "text",
            "validators": [
                // "required"
            ],
            deps:['google_address'],
            default:(item, updatedField, selectedItem) => {
                if(updatedField.value == 'google_address') {
                    if(selectedItem && selectedItem.longitude)
                        return selectedItem.longitude
                }
            },
            readonly: item => { return !item.country_code ? true : false },
        },


        {
            md: 8,
            "value": "info",
            "text": "Info",
            "type": "text",
            "validators": [
                // "required"
            ]         
        },


        // {
        //     mini:true,
        //     "value": "cost",
        //     "text": "Shipment Cost (EMN Logistic only)",
        //     "type": "text",
        // },

        {
            slim:true,
            "value": "ref_name",
            "text": "Referent name",
            "type": "text",
            "validators": [
                "required"
            ]         
        },

        {
            slim:true,
            "value": "ref_surname",
            "text": "Referent surname",
            "type": "text",
            "validators": [
                "required"
            ]         
        },

        {
            slim:true,
            "value": "ref_tel",
            "text": "Referent tel",
            "type": "text",
            "validators": [
                "required"
            ]         
        },

        {
            slim:true,
            "value": "ref_email",
            "text": "Referent email",
            "type": "text",
            "validators": [
                "required","email"
            ]         
        },


        {
            slim:true,
            "value": "ref1_name",
            "text": "Referent 1 name",
            "type": "text",
            "validators": [
            ]         
        },

        {
            slim:true,
            "value": "ref1_surname",
            "text": "Referent 1 surname",
            "type": "text",
            "validators": [
            ]         
        },

        {
            slim:true,
            "value": "ref1_tel",
            "text": "Referent 1 tel",
            "type": "text",
            "validators": [
            ]         
        },

        {
            slim:true,
            "value": "ref1_email",
            "text": "Referent 1 email",
            "type": "text",
            "validators": [
                "email_not_required"
            ]         
        },


        {
            slim:true,
            "value": "ref2_name",
            "text": "Referent 2 name",
            "type": "text",
            "validators": [
            ]         
        },

        {
            slim:true,
            "value": "ref2_surname",
            "text": "Referent 2 surname",
            "type": "text",
            "validators": [
            ]         
        },

        {
            slim:true,
            "value": "ref2_tel",
            "text": "Referent 2 tel",
            "type": "text",
            "validators": [
            ]         
        },

        {
            slim:true,
            "value": "ref2_email",
            "text": "Referent 2 email",
            "type": "text",
            "validators": [
                "email_not_required"
            ]         
        },


        



    ],
    actions: [
        // { "value": "update", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
        "upsert", "audit_trail"
        // { "value": "export", "text": "Export", "icon": "mdi-microsoft-excel", "color": "primary" }
    ]
}